import Phaser from 'phaser';

export class HUD {
  private clockText: Phaser.GameObjects.Text;
  private phaseText: Phaser.GameObjects.Text;
  private moneyDirtyText: Phaser.GameObjects.Text;
  private moneyCleanText: Phaser.GameObjects.Text;
  private container: Phaser.GameObjects.Container;

  constructor(private scene: Phaser.Scene) {
    this.container = scene.add.container(0, 0);
    this.container.setScrollFactor(0);
    this.container.setDepth(1000);

    // Top-left: clock + phase
    const clockBg = scene.add.rectangle(80, 24, 150, 40, 0x000000, 0.6).setOrigin(0.5);
    this.clockText = scene.add
      .text(20, 14, '07:00', {
        fontSize: '18px',
        fontFamily: 'monospace',
        color: '#ffffff',
      })
      .setOrigin(0, 0.5);

    this.phaseText = scene.add
      .text(20, 34, 'DAY', {
        fontSize: '12px',
        fontFamily: 'monospace',
        color: '#ffb347',
      })
      .setOrigin(0, 0.5);

    // Top-right: money
    const { width } = scene.scale;
    const moneyBg = scene.add.rectangle(width - 100, 24, 180, 40, 0x000000, 0.6).setOrigin(0.5);

    this.moneyDirtyText = scene.add
      .text(width - 185, 14, '$500 dirty', {
        fontSize: '14px',
        fontFamily: 'monospace',
        color: '#ff6b6b',
      })
      .setOrigin(0, 0.5);

    this.moneyCleanText = scene.add
      .text(width - 185, 34, '$0 clean', {
        fontSize: '14px',
        fontFamily: 'monospace',
        color: '#69db7c',
      })
      .setOrigin(0, 0.5);

    this.container.add([
      clockBg,
      this.clockText,
      this.phaseText,
      moneyBg,
      this.moneyDirtyText,
      this.moneyCleanText,
    ]);
  }

  updateTime(gameTime: number, dayPhase: string): void {
    const hours = Math.floor(gameTime / 60);
    const minutes = gameTime % 60;
    this.clockText.setText(
      `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`,
    );

    const phaseColors: Record<string, string> = {
      NIGHT: '#6c5ce7',
      DAWN: '#ffb347',
      DAY: '#ffeaa7',
      DUSK: '#ff6b35',
    };
    this.phaseText.setText(dayPhase);
    this.phaseText.setColor(phaseColors[dayPhase] ?? '#ffffff');
  }

  updateMoney(dirty: number, clean: number): void {
    this.moneyDirtyText.setText(`$${Math.floor(dirty)} dirty`);
    this.moneyCleanText.setText(`$${Math.floor(clean)} clean`);
  }

  getGameObjects(): Phaser.GameObjects.GameObject[] {
    return [this.container];
  }
}
